import Model from './Model';

export default class ServiceProvider extends Model {
  resource() {
    return 'service-providers';
  }
}
